<div class="row mb-2">
  <div class="col-sm-12">
    <label class="d-block" translate>List Label</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="list_label" [(ngModel)]="component.element.list_label" (ngModelChange)="onLabelChange($event)">
    </mat-form-field>
  </div>
</div>

<div class="row mb-2">
  <div class="col-sm-12">
    <label class="d-block" translate>Field name</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="field_name" [(ngModel)]="component.element.field_name" #fieldName="ngModel" required pattern="^[^\s\W]+$" maxlength="100">
      <mat-hint translate>Max 100 characters</mat-hint>
      <mat-error *ngIf="fieldName.invalid && fieldName.touched">
        Field name is mandatory and should not contain spaces or special characters.
      </mat-error>
    </mat-form-field>
  </div>
</div>

<div class="row mb-2">
  <div class="col-sm-12">
    <label class="d-block">Select List Type</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <mat-select [(ngModel)]="component.element.listtype" #listType="ngModel" required
        (selectionChange)="onChangeListType($event)">
        <mat-option value="" disabled>Select List Type</mat-option>
        <!-- <mat-option value="checklist">Check List</mat-option> -->
        <mat-option value="dataviewlist">Data View List(Form)</mat-option>
        <mat-option value="reportlist">Summary Report List</mat-option>
        <mat-option value="inputlist">List As Input</mat-option>
      </mat-select>
      <mat-error *ngIf="listType.invalid && listType.touched">
        List Type is mandatory.
      </mat-error>
    </mat-form-field>
  </div>
</div>
<div class="row mb-2" *ngIf="component.element.listtype === 'reportlist'">
  <div class="col-sm-12">
    <label class="d-block">Select Form</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <mat-select [(ngModel)]="component.element.tableName" #tableName="ngModel" panelClass="testClass" name="Status">
        <mat-select-filter [placeholder]="'Search'" [displayMember]="'form_name'" [array]="pageList"
          (filteredReturn)="filteredPages = $event"></mat-select-filter>
        <mat-option *ngFor="let page of filteredPages" [value]="page.id">
          {{page.form_name}}
        </mat-option>
      </mat-select>
      <mat-error class="error-msg" *ngIf="tableName.invalid && tableName.touched">Page field is required</mat-error>
    </mat-form-field>

  </div>
</div>
<div class="row mb-2">
  <div class="col-sm-12">
    <label class="d-block">Select Data Source Type</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <mat-select [(ngModel)]="component.element.datasource" #datasourceType="ngModel" required
        (selectionChange)="onChangeDatasourcetype($event)">
        <mat-option value="" disabled>Select Data Source Type</mat-option>
        <mat-option value="value">Value</mat-option>
        <mat-option value="url">API/URL</mat-option>
        <!-- <mat-option value="query">Custom Query</mat-option> -->
      </mat-select>
      <mat-error *ngIf="datasourceType.invalid && datasourceType.touched">
        Data Source Type is mandatory.
      </mat-error>
    </mat-form-field>
  </div>
</div>


<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <div class="col-sm-12">
    <label class="d-block">Choose API</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <mat-select [(ngModel)]="component.element.apiEndpoint" (selectionChange)="onChangeAPI($event.value)">
        <mat-select-filter [placeholder]="'Search'" [displayMember]="'APIAliasName'" [array]="apiList"
          (filteredReturn)="filteredAPIS = $event"></mat-select-filter>
        <mat-option *ngFor="let api of filteredAPIS" [value]="api.id">
          {{ api.APIAliasName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <div class="col-sm-12">
    <label class="d-block" translate>Http Request Type (GET, POST, PUT...)</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="requestType" placeholder="get, post, put, patch, delete"
        [(ngModel)]="component.element.requestType">
    </mat-form-field>
  </div>
</div>
<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <div class="col-sm-12">
    <label class="d-block" translate>Data Source URL</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="datasourceurl" [(ngModel)]="component.element.datasourceUrl">
    </mat-form-field>
  </div>
</div>
<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <div class="col-sm-12">
    <label class="d-block" translate>Data Source Parameters (JSON)</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="datasourceparameters" placeholder="{'EG_Id': 0, 'PT_Id': 0}"
        [(ngModel)]="component.element.datasourceParamaters">
    </mat-form-field>
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'url'">
  <div class="col-sm-12">
    <label class="d-block" translate>ResultSet (List) Name</label>
    <mat-form-field appearance="outline" class="w-100 no-outline">
      <input matInput type="text" name="resultsetName" placeholder="groupList" [(ngModel)]="component.element.resultsetName">
    </mat-form-field>
  </div>
</div>

<!-- <div class="row mb-2" *ngIf="datasource === 'url' && component.elementName === 'list'">
  <label class="col-sm-12" translate>ResultSet Field Name Text,Value(Json)</label>
  <div class="col-sm-12">
    <input type="text" name="resultsetfieldName" placeholder="{'text': 'name' ,'value': 'id' }"
      [(ngModel)]="component.element.resultsetfieldName" class="form-control form-control-sm">
  </div>
</div> -->

<div class="col-sm-12" *ngIf="component.element.datasource === 'url'">
  <label class="col-sm-12" translate>Column Definition list</label>
  <table class="table table-sm">
    <tbody>
      <tr *ngFor="let option of component.element.columnDefs; let idx = index;">
        <td class="text-center align-middle">
          <button class="btn btn-sm text-danger" (click)="addColDefs()">
            <i class="fas fa-add color-blue"></i>
          </button>
          <button class="btn btn-sm text-danger" (click)="removeColumns(idx)">
            <i class="fas fa-trash color-red"></i>
          </button>
        </td>
        <td>
          <div class="input-group input-group-sm mb-1">
            <span class="input-group-text option-key-value" translate>Header Name</span>
            <input type="text" class="form-control" [placeholder]="'header ' + idx" [(ngModel)]="option.headerName" />
          </div>
          <div class="input-group input-group-sm">
            <span class="input-group-text option-key-value" translate>Field Name</span>
            <input type="text" class="form-control" [placeholder]="'field ' + idx" [(ngModel)]="option.field" />
          </div>
          <div style="margin: 5px;">
            <div style="display: flex; flex-wrap: wrap;">
              <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                <span translate style="margin-right: 4px;">Editable</span>
                <input type="checkbox" [(ngModel)]="option.editable" />
              </div>
              <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                <span translate style="margin-right: 4px;">Sortable</span>
                <input type="checkbox" [(ngModel)]="option.sortable" />
              </div>
              <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                <span translate style="margin-right: 4px;">Resizable</span>
                <input type="checkbox" [(ngModel)]="option.resizable" />
              </div>
              <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                <span translate style="margin-right: 4px;">Dropdown Cell</span>
                <input type="checkbox" [(ngModel)]="option.cellEditorSelect" />
              </div>
              <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                <span translate style="margin-right: 4px;">Checkbox Cell</span>
                <input type="checkbox" [(ngModel)]="option.cellEditorCheckbox" />
              </div>

              <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                <input *ngIf="option.cellEditorSelect" type="text" class="form-control" placeholder="Ex: Yes, No"
                  [(ngModel)]="option.cellEditorParamsValues" />
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <button class="btn btn-link btn-sm" (click)="addColumns()">
    <i class="fas fa-plus me-2"></i> <span>Add Columns</span>
  </button>
  <div class="row mb-2">
    <div class="col-sm-8">
      <label class="d-block" translate>Initial Rows</label>
      <mat-form-field appearance="outline" class="w-100 no-outline">
        <input matInput type="number" min="0" max="99999" [(ngModel)]="component.element.initialRowCount" placeholder="e.g. 5" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);" />
      </mat-form-field>
    </div>
    <div class="col-sm-4 d-flex align-items-center">
      <button class="btn btn-primary btn-sm w-100" style="margin-top: 8px;" (click)="generateRows()">
        Generate Rows
      </button>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-sm-12">
      <label class="d-block" translate>Pagination Page Size</label>
      <mat-form-field appearance="outline" class="w-100 no-outline">
        <input matInput type="number" name="paginationPageSizeValue" min="1" placeholder="e.g. 10" [(ngModel)]="component.element.paginationPageSize" max="99999" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);"  />
      </mat-form-field>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-sm-12">
      <label class="d-block" translate>Grid Height (px)</label>
      <mat-form-field appearance="outline" class="w-100 no-outline">
        <input matInput type="number" name="gridHeight" min="100" placeholder="e.g. 500" [(ngModel)]="component.element.gridHeight" max="99999" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);"  />
      </mat-form-field>
    </div>
  </div>
  <!-- <button class="btn btn-link btn-sm" (click)="openAGGridDataModel()">
    <i class="fas fa-plus me-2"></i> <span>Add Data</span>
  </button> -->
  <div class="row mb-2">
    <div class="col-sm-12">
      <div class="d-flex flex-wrap align-items-center gap-3">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="buttonEditUrl" [(ngModel)]="component.element.buttonEdit" />
          <label class="form-check-label" for="buttonEditUrl" translate style="color: blue;">
            Add Edit Button
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="buttonDeleteUrl" [(ngModel)]="component.element.buttonDelete" />
          <label class="form-check-label" for="buttonDeleteUrl" translate style="color: red;">
            Add Delete Button
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row mb-2" *ngIf="component.element.datasource === 'value'">
  <label class="col-sm-12" translate>Column Definition list</label>
  <div class="col-sm-12">
    <table class="table table-sm">
      <tbody>
        <tr *ngFor="let option of component.element.columnDefs; let idx = index;">
          <td class="text-center align-middle">
            <button class="btn btn-sm text-danger" (click)="addColDefs()">
              <i class="fas fa-add color-blue"></i>
            </button>
            <button class="btn btn-sm text-danger" (click)="removeColumns(idx)">
              <i class="fas fa-trash color-red"></i>
            </button>
          </td>
          <td>
            <div class="input-group input-group-sm mb-1">
              <span class="input-group-text option-key-value" translate>Header Name</span>
              <input type="text" class="form-control" [placeholder]="'header ' + idx" [(ngModel)]="option.headerName" />
            </div>
            <div class="input-group input-group-sm">
              <span class="input-group-text option-key-value" translate>Field Name</span>
              <input type="text" class="form-control" [placeholder]="'field ' + idx" [(ngModel)]="option.field" />
            </div>
            <div style="margin: 5px;">
              <div style="display: flex; flex-wrap: wrap;">
                <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                  <span translate style="margin-right: 4px;">Editable</span>
                  <input type="checkbox" [(ngModel)]="option.editable" />
                </div>
                <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                  <span translate style="margin-right: 4px;">Sortable</span>
                  <input type="checkbox" [(ngModel)]="option.sortable" />
                </div>
                <div style="flex: 1 1 33.33%; display: flex; align-items: center; padding: 2px;">
                  <span translate style="margin-right: 4px;">Resizable</span>
                  <input type="checkbox" [(ngModel)]="option.resizable" />
                </div>
                <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                  <span translate style="margin-right: 4px;">Dropdown Cell</span>
                  <input type="checkbox" [(ngModel)]="option.cellEditorSelect" />
                </div>
                <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                  <span translate style="margin-right: 4px;">Checkbox Cell</span>
                  <input type="checkbox" [(ngModel)]="option.cellEditorCheckbox" />
                </div>

                <div style="flex: 1 1 50%; display: flex; align-items: center; padding: 2px;">
                  <input *ngIf="option.cellEditorSelect" type="text" class="form-control" placeholder="Ex: Yes, No"
                    [(ngModel)]="option.cellEditorParamsValues" />
                </div>
              </div>
            </div>

          </td>
        </tr>
      </tbody>
    </table>

    <button class="btn btn-link btn-sm" (click)="addColumns()">
      <i class="fas fa-plus me-2"></i> <span>Add Columns</span>
    </button>
    <button class="btn btn-link btn-sm" (click)="openAGGridDataModel()">
      <i class="fas fa-plus me-2"></i> <span>Add Data</span>
    </button>
    <div class="row mb-2">
      <div class="col-sm-8">
        <label class="d-block" translate>Initial Rows</label>
        <mat-form-field appearance="outline" class="w-100 no-outline">
          <input matInput type="number" min="0" max="99999" [(ngModel)]="component.element.initialRowCount" placeholder="e.g. 5" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);" />
        </mat-form-field>
      </div>
      <div class="col-sm-4 d-flex align-items-center">
        <button class="btn btn-primary btn-sm w-100" style="margin-top: 8px;" (click)="generateRows()">
          Generate Rows
        </button>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-sm-12">
        <label class="d-block" translate>Pagination Page Size</label>
        <mat-form-field appearance="outline" class="w-100 no-outline">
          <input matInput type="number" name="paginationPageSizeValue" min="1" placeholder="e.g. 10" [(ngModel)]="component.element.paginationPageSize" max="99999" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);">
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-sm-12">
        <label class="d-block" translate>Grid Height (px)</label>
        <mat-form-field appearance="outline" class="w-100 no-outline">
          <input matInput type="number" name="gridHeightValue" min="100" placeholder="e.g. 500" [(ngModel)]="component.element.gridHeight" max="99999" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);">
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-sm-12">
        <div class="d-flex flex-wrap align-items-center gap-3">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="buttonEditValue" [(ngModel)]="component.element.buttonEdit" />
            <label class="form-check-label" for="buttonEditValue" translate style="color: blue;">
              Add Edit Button
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="buttonDeleteValue" [(ngModel)]="component.element.buttonDelete" />
            <label class="form-check-label" for="buttonDeleteValue" translate style="color: red;">
              Add Delete Button
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




<!-- <div class="row mb-2" *ngIf="datasource === 'value'">
  <label class="mb-1 col-sm-12" translate>Column Definition list</label>
  <div class="col-sm-12">
    <table class="table table-sm">
      <tbody>
        <tr *ngFor="let option of component.element.columnDefs; let idx = index;">
          <td class="text-center align-middle">
            <button class="btn btn-sm text-danger" (click)="addColDefs()">
              <i class="fas fa-add color-blue"></i>
            </button>
            <button class="btn btn-sm text-danger" (click)="removeColumns(idx)">
              <i class="fas fa-trash color-red"></i>
            </button>
          </td>
          <td>
            <div class="input-group input-group-sm mb-1">
              <span class="input-group-text option-key-value" translate>Header Name</span>
              <input type="text" class="form-control" [placeholder]="'header ' + idx" [(ngModel)]="option.headerName" />
            </div>
            <div class="input-group input-group-sm">
              <span class="input-group-text option-key-value" translate>Field Name</span>
              <input type="text" class="form-control" [placeholder]="'field ' + idx" [(ngModel)]="option.field" />
            </div>
            <div style="margin: 5px;">
              <span translate class="me-2">Editable</span>
              <input class="me-2" type="checkbox" [(ngModel)]="option.editable" />
              <span translate class="me-2">Sortable</span>
              <input class="me-2" type="checkbox" [(ngModel)]="option.sortable" />
              <span translate class="me-2">Resizable</span>
              <input class="me-2" type="checkbox" [(ngModel)]="option.resizable" />
              <span translate class="me-2">Dropdown Cell Editor</span>
              <input class="me-2" type="checkbox" [(ngModel)]="option.cellEditorSelect" />
              <input *ngIf="option.cellEditorSelect === true" type="text" class="form-control" [placeholder]="['Ex: Yes','No']"
                [(ngModel)]="cellEditorParamsValues" />
                <span translate class="me-2">Checkbox Cell Editor</span>
                <input class="me-2" type="checkbox" [(ngModel)]="option.cellEditorCheckbox" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="btn btn-link btn-sm" (click)="addColumns()">
      <i class="fas fa-plus me-2"></i> <span>Add Columns</span>
    </button>
    <button class="btn btn-link btn-sm" (click)="openAGGridDataModel()">
      <i class="fas fa-plus me-2"></i> <span>Add Data</span>
    </button>
  </div>
</div> -->

<ng-template #AgGridRowDataPoup>
  <div mat-dialog-title class="mat-title">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="main-title">Add Row Data</h1>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>

    <mat-form-field appearance="outline" class="rowdata-text-full-width">
      <textarea [(ngModel)]="jsonInput" matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="20"
        placeholder="[{field1: 'field1 data', field2: 'field2 data', field3: 'field3 data', field4: 'field4 data'}]"></textarea>
    </mat-form-field>
    <div class="btn-position">
      <!-- <button mat-raised-button color="accent" class="btn-accent" >{{langObj ? langObj?.save : ('save' | translate)}}</button> -->
      <button mat-mini-fab color="primary" type="submit" tooltipPosition="top" (click)="addData()">
        <mat-icon style="color: #fff">add</mat-icon>
      </button>
    </div>
  </div>

</ng-template>